import { store } from "@store/index";
import {
  clearLayoutDraft,
  fetchPage,
  selectLayoutDraft,
} from "@store/features/crm/pageV2Slice";
import { trpc } from "@utils/api";
import { toast } from "sonner";
import { clearLayoutModifiedToast } from "./layoutModifiedToast";
import { clearEphemeralQueryFromUrl } from "../helpers/pageNavigation";
import {
  mergeBaseQueryForSave,
  readEphemeralQueryFromLocation,
  resolveEffectivePageBaseQuery,
} from "./mergeBaseQueryForSave";

let isSaving = false;

export const savePageLayoutDraft = async (): Promise<boolean> => {
  if (isSaving) {
    return false;
  }

  const state = store.getState();
  const draft = selectLayoutDraft(state);
  const pageData = state.pageV2.data;

  if (!draft || !pageData) {
    return false;
  }

  isSaving = true;

  try {
    const effectiveBaseQuery = resolveEffectivePageBaseQuery(
      pageData,
      draft,
    );

    const ephemeralQuery = readEphemeralQueryFromLocation();
    const mergedBaseQuery = mergeBaseQueryForSave(
      effectiveBaseQuery,
      ephemeralQuery.filters,
      ephemeralQuery.sort,
    );

    await trpc.crm.savePageLayout.mutate({
      pageId: draft.pageId,
      blockId: draft.blockId,
      config: draft.draftConfig,
      baseQuery: mergedBaseQuery,
    });

    toast.success("Layout saved");
    store.dispatch(clearLayoutDraft());
    clearLayoutModifiedToast();

    clearEphemeralQueryFromUrl({
      clearLayout: true,
      clearFilters: true,
      clearSort: true,
    });

    const currentPath = pageData.path;
    if (currentPath) {
      void store.dispatch(fetchPage({ path: currentPath }));
    }

    return true;
  } catch (error) {
    console.error("Failed to save layout:", error);
    toast.error(
      error instanceof Error ? error.message : "Failed to save layout",
    );
    return false;
  } finally {
    isSaving = false;
  }
};
